export default __webpack_public_path__ + "static/media/ministerio_desenvolvimento.d2152020.png";